import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { PageHeader } from "../components/AppLayout";
import { ExternalLink, TrendingUp, TrendingDown, Minus, ShieldCheck, ArrowRight } from "lucide-react";

const TREND_ICON = { up: TrendingUp, down: TrendingDown, flat: Minus };
const TREND_COLOR = { up: "#DC2626", down: "#16A34A", flat: "#64748B" };

export default function Inspection() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/inspection").then((r) => setData(r.data)); }, []);
  if (!data) return <div className="text-slate-400">Caricamento...</div>;
  const max = Math.max(...data.trends.map((t) => t.count), 1);

  return (
    <div className="ri-fade-in">
      <PageHeader overline="Inspection Intelligence" title="Inspection Intelligence"
        subtitle="Trend ispettivi per tassonomia ed enforcement. Dato quantitativo (illustrativo, DEMO) separato dall'interpretazione. Le fonti puntano ai database ufficiali."
        actions={<Link to="/app/readiness" data-testid="go-readiness-btn" className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg bg-blue-700 text-white text-sm hover:bg-blue-800"><ShieldCheck size={15} /> Inspection Readiness</Link>} />

      <div className="grid lg:grid-cols-3 gap-5">
        <div className="lg:col-span-2 rounded-xl bg-white border border-slate-200 p-5">
          <h3 className="font-head font-semibold text-sm mb-1">Trend per tassonomia</h3>
          <p className="text-xs text-slate-400 mb-4">Conteggi illustrativi (DEMO) — verificare sempre le fonti ufficiali.</p>
          <div className="space-y-3">
            {data.trends.map((t, i) => {
              const Icon = TREND_ICON[t.trend] || Minus;
              return (
                <div key={i} data-testid={`trend-${i}`}>
                  <div className="flex items-center justify-between text-sm mb-1">
                    <span className="font-medium capitalize">{t.category}</span>
                    <span className="flex items-center gap-2 text-xs text-slate-500">
                      <span className="font-mono">{t.authority}</span>
                      <Icon size={14} style={{ color: TREND_COLOR[t.trend] }} />
                      <span className="font-mono font-semibold" style={{ color: TREND_COLOR[t.trend] }}>{t.count}</span>
                    </span>
                  </div>
                  <div className="h-2 rounded-full bg-slate-100 overflow-hidden">
                    <div className="h-full rounded-full" style={{ width: `${(t.count / max) * 100}%`, background: TREND_COLOR[t.trend] }} />
                  </div>
                  <p className="text-xs text-slate-400 mt-1">{t.note}</p>
                </div>
              );
            })}
          </div>
        </div>

        <div className="space-y-4">
          <div className="rounded-xl bg-white border border-slate-200 p-5">
            <h3 className="font-head font-semibold text-sm mb-3">Fonti ufficiali</h3>
            <div className="space-y-3">
              {data.findings.map((f) => (
                <a key={f.id} href={f.url} target="_blank" rel="noreferrer" data-testid={`insp-source-${f.id}`}
                  className="block rounded-lg border border-slate-200 p-3 hover:border-blue-400 transition-colors">
                  <div className="flex items-center gap-2 text-xs text-slate-400 font-mono mb-1">{f.authority} · {f.kind}</div>
                  <div className="text-sm font-medium flex items-center gap-1">{f.title} <ExternalLink size={12} className="text-blue-600" /></div>
                  <div className="text-xs text-slate-500 mt-1">{f.description}</div>
                </a>
              ))}
            </div>
          </div>
          <div className="rounded-xl bg-white border border-slate-200 p-5">
            <h3 className="font-head font-semibold text-sm mb-2">Tassonomia findings</h3>
            <div className="flex flex-wrap gap-1.5">
              {data.taxonomy.map((t) => <span key={t} className="text-xs px-2 py-0.5 rounded-md bg-slate-100 text-slate-600">{t}</span>)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
